import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';

const AlertModal = ({ isOpen, toggle, editingAlert, formData, setFormData, onSubmit }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {editingAlert ? 'Chỉnh sửa Alert' : 'Tạo Alert Mới'}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Loại Alert *</Label>
                <Input
                  type="select"
                  value={formData.type}
                  onChange={(e) => setFormData({...formData, type: e.target.value})}
                  required
                >
                  <option value="success">Success</option>
                  <option value="error">Error</option>
                  <option value="warning">Warning</option>
                  <option value="info">Info</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Key *</Label>
                <Input
                  type="text"
                  value={formData.key}
                  onChange={(e) => setFormData({...formData, key: e.target.value})}
                  placeholder="customSuccess"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Message *</Label>
                <Input
                  type="text"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  placeholder="Thành công tùy chỉnh!"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Description</Label>
                <Input
                  type="textarea"
                  rows="3"
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  placeholder="Mô tả cho alert message..."
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Sort Order</Label>
                <Input
                  type="number"
                  value={formData.sortOrder}
                  onChange={(e) => setFormData({...formData, sortOrder: parseInt(e.target.value)})}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="d-block">Trạng thái</Label>
                <div className="form-check form-switch mt-2">
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                  />
                  <Label className="form-check-label">
                    {formData.isActive ? 'Active' : 'Inactive'}
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" type="submit">
            <i className="fa fa-save me-2"></i>
            {editingAlert ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AlertModal;

